export const reactGridLayoutStyle = {
  '.react-grid-item.react-grid-placeholder': {
    background: 'blueGray.400',
    borderRadius: 'lg',
  },
  // https://github.com/react-grid-layout/react-grid-layout/issues/1329
  '.react-resizable-hide .react-resizable-handle': {
    display: 'none !important',
  },
}
